/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ImportSageIntacctCustomersInput = {
    sageIntacctCustomerIds?: Array<string | null> | null | undefined;
    companyId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type ImportSageIntacctCustomersMutationVariables = {
    input: ImportSageIntacctCustomersInput;
};
export type ImportSageIntacctCustomersMutationResponse = {
    readonly importSageIntacctCustomers: {
        readonly clients: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly notes: string | null;
                readonly logoId: string | null;
                readonly logoDefaultId: number | null;
                readonly projectCount: number | null;
                readonly economicCustomerId: string | null;
                readonly quickbooksCustomerId: string | null;
                readonly xeroContactId: string | null;
                readonly salesforceAccountId: string | null;
                readonly hubspotCompanyId: string | null;
                readonly pipedriveOrganizationId: string | null;
                readonly sageIntacctCustomerId: string | null;
            } | null;
        } | null> | null;
    } | null;
};
export type ImportSageIntacctCustomersMutation = {
    readonly response: ImportSageIntacctCustomersMutationResponse;
    readonly variables: ImportSageIntacctCustomersMutationVariables;
};



/*
mutation ImportSageIntacctCustomersMutation(
  $input: ImportSageIntacctCustomersInput!
) {
  importSageIntacctCustomers(input: $input) {
    clients {
      node {
        id
        name
        notes
        logoId
        logoDefaultId
        projectCount
        economicCustomerId
        quickbooksCustomerId
        xeroContactId
        salesforceAccountId
        hubspotCompanyId
        pipedriveOrganizationId
        sageIntacctCustomerId
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportSageIntacctCustomersInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctCustomersPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctCustomers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroContactId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveOrganizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctCustomerId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctCustomersMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctCustomersMutation(\n  $input: ImportSageIntacctCustomersInput!\n) {\n  importSageIntacctCustomers(input: $input) {\n    clients {\n      node {\n        id\n        name\n        notes\n        logoId\n        logoDefaultId\n        projectCount\n        economicCustomerId\n        quickbooksCustomerId\n        xeroContactId\n        salesforceAccountId\n        hubspotCompanyId\n        pipedriveOrganizationId\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '3f7dd249af9ee6aa611df29c43619138';
export default node;
